const Banner = '/assets/buseslafit/general/lafit-banner.webp';
const HeaderLogo = '/assets/kennybus/general/kennybus-header-logo.png';
const FooterLogo = '/assets/kennybus/general/kennybus-footer-logo-white.png';

const BookingInActive = '/assets/buseslafit/icons/nsbuy.svg';
const BookingActive = '/assets/buseslafit/icons/compra.svg';
const CancelInActive = '/assets/buseslafit/icons/nsanular.svg';
const CancelActive = '/assets/buseslafit/icons/anular.svg';

const Whatsapp = '/assets/kennybus/icons/whatsapp.svg';
const Email = '/assets/buseslafit/icons/email.svg';
const HeadPhone = '/assets/buseslafit/icons/contact.svg';
const YellowLine = '/assets/buseslafit/line/line.svg';

// emailoffice = '/assets/buseslafit/icons/email-office.svg';

const OriginIcon = '/assets/buseslafit/icons/origin.svg';
const DestinationIcon = '/assets/buseslafit/icons/destino.svg';
const pin = '/assets/buseslafit/icons/destino.svg';

const CalendarIcon = '/assets/buseslafit/icons/calendar.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation =
	'/assets/santarosa/icons/animation.gif';
const pnr = '/assets/buseslafit/general/lafitpnr.svg';

const PopupIcon = '/assets/kennybus/general/Pop-up.jpg';

// Icons Section
const ist = '/assets/buseslafit/icons/seat-icon.svg';
const second = '/assets/buseslafit/icons/charging-icon.svg';
const third = '/assets/buseslafit/icons/phone-icon.svg';
const close = '/assets/kennybus/icons/close.svg';

const success = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-CheckMark-Gray.svg';
const failure = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-Information-Gray.svg';

const tick = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-Tick-Gray.svg';
const heartOn = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-HeartOn-Gray.svg';
const heartOff = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-HeartOff-Gray.svg';
const downArrow = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-DropDown-Gray.svg';
const registrationSuccess = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-RightDocument-Gray.svg';
const userIcon = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-Login-Gray.svg';
const trips = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-MyTrips-Gray.svg';
const cards = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-MyCards-Gray.svg';
const wallet = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const transaction = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-ShareMoney-Gray.svg';
const otp = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-RestorePassword-Gray.svg';

const paso_1 = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const paso_2 = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-RechargePoints-Gray.svg';
const paso_3 = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-ID-Gray.svg';
const paso_4 = '/assets/buseslafit/Gray/MyAccount-IllustratedIcons-Tickets-Gray.svg';


const lafitIcons = [

	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: Banner, name: 'Banner' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },




	// { icon: emailoffice, name: 'emailoffice' },
	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: pin, name: 'pin' },
	{ icon: CalendarIcon, name: 'Calendar' },

	{ icon: BookingInActive, name: 'BIA' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: CancelActive, name: 'CA' },

	{ icon: PopupIcon, name: 'Popup' },

	{ icon: Whatsapp, name: 'Whatsapp' },
	{ icon: Email, name: 'Email' },
	{ icon: HeadPhone, name: 'Headphone' },
	{ icon: YellowLine, name: 'Line' },

	{ icon: animation, name: 'animation' },
	{ icon: checkboxIcon, name: 'Checkbox' },

	// Icons Section
	{ icon: ist, name: 'ist' },
	{ icon: second, name: 'second' },
	{ icon: third, name: 'third' },
	{ icon: pnr, name: 'pnr' },
	{ icon: close, name: 'close' },
];

export default lafitIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/lafitIcons.js